import { createTheme, PaletteMode } from "@mui/material/styles";

export function createUniboxTheme(mode: PaletteMode) {
  const isDark = mode === "dark";

  return createTheme({
    palette: {
      mode,
      primary: {
        main: isDark ? "#4dd0e1" : "#00bbcd",
      },
      secondary: {
        main: isDark ? "#22d3ee" : "#00a5b5",
      },
      background: {
        default: isDark ? "#14171b" : "#f1f5f9",
        paper: isDark ? "#2d333b" : "#ffffff",
      },
      text: {
        primary: isDark ? "#f8fafc" : "#0f172a",
        secondary: isDark ? "#cbd5e1" : "#64748b",
      },
      divider: isDark ? "rgba(148, 163, 184, 0.28)" : "rgba(148, 163, 184, 0.25)",
      action: {
        hover: isDark ? "rgba(148, 163, 184, 0.08)" : "rgba(15, 23, 42, 0.04)",
        selected: isDark ? "rgba(0, 187, 205, 0.18)" : "rgba(0, 187, 205, 0.1)",
      },
    },
  shape: {
    borderRadius: 10,
  },
    typography: {
      fontFamily: "Inter, Segoe UI, Arial, sans-serif",
      button: {
        textTransform: "none",
        fontWeight: 600,
      },
    },
    components: {
      MuiCssBaseline: {
        styleOverrides: {
          body: {
            backgroundColor: isDark ? "#14171b" : "#f1f5f9",
          },
        },
      },
      MuiPaper: {
        styleOverrides: {
          root: {
            backgroundImage: "none",
            boxShadow: isDark
              ? "0 10px 30px rgba(0, 0, 0, 0.35)"
              : "0 10px 30px rgba(15, 23, 42, 0.08)",
          },
        },
      },
      MuiButton: {
        styleOverrides: {
          root: {
            borderRadius: 10,
          },
        },
      },
      MuiDialog: {
        styleOverrides: {
          paper: {
            borderRadius: 14,
          },
        },
      },
      MuiOutlinedInput: {
        styleOverrides: {
          root: {
            backgroundColor: isDark ? "#2a3038" : "#fff",
          },
        },
      },
    },
  });
}

/** @deprecated use createUniboxTheme('light') */
export const uniboxTheme = createUniboxTheme("light");
